module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAARVBMVEUAAABVqlUzmWYrqlU3qlA4q1A7qVM4qVI5qlE4qlE5qlE5qlI5qlE5qlE5qlI5qlE5qlE5qlE5qlE5qlE5qlE5qlE5qlGaPTyiAAAAFnRSTlMAAwUGM0lKer2+wMjJytvk5uf6+/z9D5SB1wAAAJpJREFUOMvl1WELhCAMBuAuXXnXXZl39/7/nxpB1ohwk6CI9snBA06csyiuGuQCEhEcMQsxFv1CbVIbmxpuTn54pMs0CPMakA7FxO2wbVurxh+gUeM/2CVIeGyGW2DyntTYA16Nl3L24lijCscaVXiNTsaxRaUD9lPzv3m+iau+q/izivlBrztrMEojt+QjN2uYS9/E90mX/QEHya8ib6nOftcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/course/cjzt@2x.png
// module id = k+XR
// module chunks = 0